import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card } from "../components/ui/card";
import { Compass, AlertCircle } from "lucide-react";
import { toast } from "sonner";
import GoogleLoginButton from "../components/GoogleLoginButton";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Bentornato!");
      const to = loc.state?.from || "/";
      navigate(to, { replace: true });
    } catch (e2) {
      setErr(e2.response?.data?.detail || "Errore login");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-parchment-grain flex items-center justify-center p-4">
      <Card className="card-treasure p-8 w-full max-w-md animate-bounce-in">
        <div className="flex flex-col items-center mb-6">
          <div className="w-16 h-16 rounded-3xl bg-gold flex items-center justify-center shadow-tactile mb-3">
            <Compass className="text-ink-900" size={32} strokeWidth={2.6} />
          </div>
          <h1 className="text-3xl font-display font-extrabold text-ink-900">Odismap</h1>
          <p className="text-ink-500 text-sm">Esplora. Risolvi. Vinci.</p>
        </div>
        <form onSubmit={onSubmit} className="space-y-4" data-testid="login-form">
          <div>
            <Label htmlFor="email" className="text-ink-800 font-bold">Email</Label>
            <Input id="email" type="email" required value={email} onChange={(e)=>setEmail(e.target.value)} className="h-12 rounded-2xl border-outline" data-testid="login-email-input" />
          </div>
          <div>
            <Label htmlFor="password" className="text-ink-800 font-bold">Password</Label>
            <Input id="password" type="password" required value={password} onChange={(e)=>setPassword(e.target.value)} className="h-12 rounded-2xl border-outline" data-testid="login-password-input" />
          </div>
          {err && <div className="flex items-center gap-2 text-sm text-compass bg-red-50 p-3 rounded-xl border border-red-200"><AlertCircle size={16}/>{err}</div>}
          <button type="submit" disabled={loading} className="btn-tactile w-full" data-testid="login-submit-btn">
            {loading ? "Accesso..." : "Accedi"}
          </button>
        </form>
        <div className="flex items-center gap-3 my-4">
          <div className="flex-1 h-px bg-outline" />
          <span className="text-xs uppercase tracking-widest text-ink-500 font-bold">oppure</span>
          <div className="flex-1 h-px bg-outline" />
        </div>
        <GoogleLoginButton testId="login-google-btn" />
        <div className="mt-4 text-center text-sm text-ink-700">
          Non hai un account? <Link to="/register" className="font-bold text-ocean" data-testid="link-register">Registrati</Link>
        </div>
      </Card>
    </div>
  );
}
